import { useState } from "react";
import InputErrorMsg from "../../form-builder-helpers/InputErrorMsg";
import SvgPencil from "./SvgPencil";
import SvgVerified from "./SvgVerified";
import RequiredStar from "@/app/components/lib/RequiredStar";
import { useLang } from "@/providers/langProvider";
import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  label: string;
  type?: string;
  inputRegister: any;
  invalid?: boolean;
  dir?: "ltr" | "rtl" | "auto";
  errorMsg?: string;
  viewPencil?: boolean;
  verifiedPosition?: number | null;
  required?: boolean;
  placeholder?: string;
  hideLabel?: boolean;
  hint?: string;
}

const HookInput: React.FC<Props> = ({
  label,
  inputRegister,
  type = "text",
  dir = "auto",
  errorMsg,
  viewPencil: viewPencil = false,
  verifiedPosition = null,
  required = false,
  placeholder,
  hideLabel,
  hint,
}) => {
  const locale = useLang();
  const isRtl = useIsRtl();
  const [focused, setFocused] = useState(false);
  return (
    <div className="form-floating" dir={isRtl ? "rtl" : "ltr"}>
      <input
        className="form-control"
        id="floatingPassword"
        {...inputRegister}
        type={type}
        placeholder={!hideLabel && !focused ? "" : placeholder ?? label}
        dir={dir}
        autoComplete="new-password"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <label htmlFor="floatingPassword">
        {!hideLabel && (
          <span>
            <RequiredStar title={label} isRequired={required} />
          </span>
        )}
        {viewPencil && !focused && locale !== "ar" && (
          <div className="pencil">
            <SvgPencil />
          </div>
        )}
        {verifiedPosition && (
          <div
            className="verified"
            style={{
              marginInlineStart:
                label && locale === "ar"
                  ? `calc(100% - ${verifiedPosition + 24}px)`
                  : verifiedPosition + 4,
            }}
          >
            <SvgVerified />
          </div>
        )}
      </label>
      {hint && <div className="field-hint">{hint}</div>}
      {errorMsg && <InputErrorMsg errorMsg={errorMsg} />}
    </div>
  );
};

export default HookInput;
